<template>
  <div class="endetfripro between">
    <div class="tishitxt flex_start">
      <img src="../../../assets/entrust/entruyqtsicon.png" alt="" />
      <span>友情提示：</span>
      律观网平台所提供的案件及接洽律师都是经过平台认证和人工核实的，保证信息真实可信。
    </div>
    <div class="kfrx center">客服热线：400-6000-8888</div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.endetfripro {
  width: 1200px;
  height: 38px;
  background: #ffebd2;
  border: 1px solid #ffd5b9;
  .tishitxt {
    padding-left: 22px;

    color: #666666;
    img {
      width: 22px;
      height: 22px;
      margin-right: 15px;
    }
    span {
      margin-right: 10px;
      color: #ff6600;
    }
  }
  .kfrx {
    width: 268px;
    height: 100%;
    background-color: #ff6600;
    font-size: 18px;
    color: #ffffff;
  }
}
</style>